import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';
import { DprOnlineApprovalReport } from '@report/models';
import { StaticMessage } from '@shared/enums';
import { DprOnlineApproval } from '@shared/models/dpr';
import {
  OnlineApprover,
  SubprojectConfigurationCustomNames,
} from '@shared/models/project-setup';

@Component({
  selector: 'app-report-online-approvals',
  templateUrl: './report-online-approvals.component.html',
  styleUrls: ['./report-online-approvals.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportOnlineApprovalsComponent implements OnInit {
  @Input({ required: true }) onlineApproverList: OnlineApprover[];
  @Input({ required: true }) dprOnlineApprovals: DprOnlineApproval[];
  @Input({ required: true }) customNames: SubprojectConfigurationCustomNames;

  onlineApprovalReport: DprOnlineApprovalReport[] = [];

  StaticMessage = StaticMessage;

  ngOnInit(): void {
    this.dprOnlineApprovals.forEach((item) => {
      this.onlineApprovalReport.push({
        approver: (this.onlineApproverList ?? []).find(
          (x) => x.accountId === item.accountId
        ).userName,
        dprOnlineApproval: item,
      });
    });
  }
}
